import { User } from '../../types';
import { Listing } from '../../types';

function isExternalManager(user: User, listing: Listing) {
  if (user.groupProfiles && listing.groupProfiles) {
    user.groupProfiles.forEach(function (item, index) {
      if (listing.groupProfiles.includes(item)) {
        return true;
      }
    });
  }
  return false;
}

export function getUserType(user: User, listing: Listing) {
  console.log(user);
  if (user.roles.includes('ROLE_SALES_DIRECTOR')) {
    return 'internal_sales_director';
  } else if (user.roles.includes('ROLE_EXTERNAL_SALES_DIRECTOR')) {
    return 'external_sales_director';
  } else if (isExternalManager(user, listing)) {
    return 'external_manager';
  } else if (user.roles.includes('ROLE_ADMIN') || user.roles.includes('ROLE_SUPERADMIN')) {
    return 'internal_manager';
  }
}
